<template>
  <v-container fluid class="pt-0">
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card color="white" tile>
            <v-row class="overflow-hidden mx-0">
              <v-col cols="12" class="py-0">
                <v-container :class="dense ? 'py-0' : ''">
                  <v-row>
                    <v-col cols="auto" class="py-0 my-auto" v-if="!hideAvatar">
                      <slot name="avatar"></slot>
                    </v-col>
                    <v-col
                      cols="auto"
                      :class="'my-auto' + (dense ? ' pb-0' : '')"
                    >
                      <div class="text-h5 primary--text">
                        <v-row>
                          <v-col cols="auto" class="font-weight-bold py-1">
                            <slot name="headerLine1"></slot>
                          </v-col>
                          <v-col cols="auto" class="py-1">
                            <slot name="headerLine1Chip"></slot>
                          </v-col>
                        </v-row>
                      </div>
                      <div class="secondarytext--text">
                        <slot name="headerLine2"></slot>
                      </div>
                    </v-col>
                    <v-spacer> </v-spacer>
                    <v-col cols="auto" class="pa-0">
                      <v-breadcrumbs :items="breadcrumbList"></v-breadcrumbs>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-row class="overflow-hidden mx-0">
              <v-col cols="12" class="pa-0">
                <v-container class="py-0">
                  <slot name="tabs"></slot>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <slot name="secondary"></slot>
      <v-container>
        <slot></slot>
      </v-container>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "DetailsHeader",
  props: {
    loading: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    hideAvatar: { type: Boolean, default: false }
  },
  data: () => ({ breadcrumbList: [] }),
  watch: {
    $route() {
      this.setBreadcrumbList();
    }
  },
  mounted() {
    this.setBreadcrumbList();
  },
  methods: {
    formatBreadcrumbList(list) {
      list.forEach(item => {
        item.text = this.t2(item.text);
      });
      return list;
    },
    setBreadcrumbList() {
      let path = this.$route.path;
      if (path === "/") {
        this.breadcrumbList = [];
        return;
      }
      let list = [
        {
          text: "Dashboard",
          to: "/"
        }
      ];
      if (this.$route.meta.breadcrumbs) {
        list = list.concat(
          this.formatBreadcrumbList(this.$route.meta.breadcrumbs)
        );
      }
      let title = this.t2(this.$route.meta.title);
      if (this.$route.meta.breadcrumbTitle) {
        title = this.t2(this.$route.meta.breadcrumbTitle);
      }
      list.push({
        text: title,
        disabled: true
      });
      this.breadcrumbList = list;
    }
  }
};
</script>
